import { lazy } from 'react';
import { Navigate } from 'react-router-dom'

const Settings = lazy(() => import('./settings/Settings'));
const Staff = lazy(() => import('./staff/Staff'));
const Permissions = lazy(() => import('./staff/Permissions'));
const WorkingHours = lazy(() => import('./staff/WorkingHours'));
const Products = lazy(() => import('./material/Products'));
const OrderProductsStatus = lazy(() => import('./material/OrderProductsStatus'));
const ProductId = lazy(() => import('./material/ProductId'));
const Category = lazy(() => import('./material/Category'));
const SubCategory = lazy(() => import('./material/Subcategory'));
const Brands = lazy(() => import('./material/Brands'));
const StoreHouses = lazy(() => import('./material/StoreHouses'));
const Suppliers = lazy(() => import('./material/Suppliers'));
const Inventory = lazy(() => import('./material/Inventory'));
const Laboratory = lazy(() => import('./material/Laboratory'));
const Repair = lazy(() => import('./material/Repair'));
const Moving = lazy(() => import('./material/Moving'));
const Salary = lazy(() => import('./salary/Salary'));
const SalarySettings = lazy(() => import('./salary/Settings'));
const BranchSalaryUser = lazy(() => import('./salary/BranchSalaryUser'));
const AutoSalary = lazy(() => import('./salary/AutoSalary'));
const SalaryCom = lazy(() => import('./salary/Consumption'));
const EmailSms = lazy(() => import('./email_sms/EmailSms'));
const EmailLetter = lazy(() => import('./email_sms/EmailLetter'));
const Balance = lazy(() => import('./email_sms/Balance'));
const History = lazy(() => import('./email_sms/History'));
const Resources = lazy(() => import('./res_ser/Resource'));
const Services = lazy(() => import('./res_ser/Services'));
const Genaral = lazy(() => import('./analytics/Genaral'));
const StaffA = lazy(() => import('./analytics/Staff'));
const Sales = lazy(() => import('./sales/Sales'));
const SalesParams = lazy(() => import('./sales/SalesParams'));
const Purchase = lazy(() => import('./purchase/Purchase'));
const PurchaseParams = lazy(() => import('./purchase/PurchaseParams'));
const InterBranch = lazy(() => import('./interBranch/InterBranch'));
const InterBranchParams = lazy(() => import('./interBranch/InterBranchParams'));
const MatrialType = lazy(() => import('./catalog/MatrialType'));
const ColourType = lazy(() => import('./catalog/Colour'));
const Specialization = lazy(() => import('./catalog/Specialization'));
const ExpenseType = lazy(() => import('./catalog/ExpenseType'));
const Type = lazy(() => import('./catalog/Type'));
const SerialType = lazy(() => import('./catalog/SerialType'));
const Option = lazy(() => import('./catalog/Option'));
const ExecutorType = lazy(() => import('./catalog/ExecutorType'));
const VentilationSize = lazy(() => import('./catalog/VentilationSize'));
const DebitOrderTransacts = lazy(() => import('./material/report/DebitOrderTransacts'));
const DebitTransacts = lazy(() => import('./material/report/DebitTransacts'));
const DebitTotalTransact = lazy(() => import('./material/report/DebitTotalTransacts'));
const DebitTransactSummary = lazy(() => import('./material/report/DebitTransactSummary'));
const FullOrderList = lazy(() => import('./material/report/FullOrderList'));
const TotalTransactSummary = lazy(() => import('./material/report/TotalTransactSummary'));
const Request = lazy(() => import('./request/Request'));
const Payments = lazy(() => import('./material/report/Payments'));
const Finance = lazy(() => import('./material/report/Finance'));
const Profile = lazy(() => import('./profile/Profile'));
const MyProfile = lazy(() => import('./profile/MyProfile'));
const Language = lazy(() => import('./profile/Language'));
const CalendarApp = lazy(() => import('../calendar/CalendarApp'));
const CalendarMobileApp = lazy(() => import('../calendar/CalendarMobileApp'));
const SearchSeria = lazy(() => import('./material/SearchSeria'));
const Home = lazy(() => import('./home/Home'));
const QrScannerPage = lazy(() => import('./qr/QrPage'));
const OrderMain = lazy(() => import('./sales/OrderMain'));
const LaboratoryParams = lazy(() => import('./sales/LaboratoryParams'));


const AdminAppConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: 'calendar/workingstaff',
      element: <CalendarApp />,
    },
    {
      path: 'calendar/mobile',
      element: <CalendarMobileApp />,
    },
    {
      path: 'profile',
      element: <Profile />,
    },
    {
      path: 'profile/my-profile',
      element: <MyProfile />,
    },
    {
      path: 'profile/language',
      element: <Language />,
    },
    {
      path: 'settings',
      element: <Settings />,
    },
    {
      path: 'staff/staff',
      element: <Staff />,
    },
    {
      path: 'staff/permissions',
      element: <Permissions />,
    },
    {
      path: 'staff/workinghours',
      element: <WorkingHours />,
    },  
    {
      path: 'products',
      element: <Products />,
    },  
    {
      path: 'material/order-products',
      element: <OrderProductsStatus />,
    },
    {
      path: 'products/:id/*',
      element: <ProductId />,
    },
    {
      path: 'seria',
      element: <Category />,
    },  
    {
      path: 'categories',
      element: <SubCategory />,
    },  
    {
      path: 'brands',
      element: <Brands />,
    },  
    {
      path: 'material/suppliers',
      element: <Suppliers />,
    },  
    {
      path: 'material/store-houses',
      element: <StoreHouses />,
    }, 
    {
      path: 'material/inventory',
      element: <Inventory />,
    },  
    {
      path: 'material/moving',
      element: <Moving />,
    },
    {
      path: 'salary',
      element: <Salary />,
    },  
    {
      path: 'salary/consumption',
      element: <SalaryCom />,
    },     
    {
      path: 'salary/settings',
      element: <SalarySettings />,
    },   
    {
      path: 'salary/user-salary',
      element: <BranchSalaryUser />,
    },
    {
      path: 'salary/user-salary-auto',
      element: <AutoSalary />,
    },     
    {
      path: 'email_sms/auto_notification',
      element: <EmailSms />,
    },   
    {
      path: 'email_sms/smsletter',
      element: <EmailLetter />,
    },   
    {
      path: 'email_sms/balance',
      element: <Balance />,
    },  
    {
      path: 'email_sms/history',
      element: <History />,
    },
    {
      path: 'resources',
      element: <Resources />,
    },
    {
      path: 'services',
      element: <Services />,
    },
    {
      path: 'analytics/general',
      element: <Genaral />,
    },
    {
      path: 'analytics/staff',
      element: <StaffA />,
    },
    {
      path: 'sales',
      element: <Sales />,
    },
    {
      path: 'sales/:id/*',
      element: <SalesParams />,
    },
    {
      path: 'sales/lab/:id/*',
      element: <LaboratoryParams />,
    },
    {
      path: 'sales/main/:id/*',
      element: <OrderMain />,
    },
    {
      path: 'purchase',
      element: <Purchase />,
    },
    {
      path: 'purchase/:id/*',
      element: <PurchaseParams />,
    },
    {
      path: 'inter-branch',
      element: <InterBranch />,
    },
    {
      path: 'inter-branch/:id/*',
      element: <InterBranchParams />,
    },
    {
      path: 'matrial-type',
      element: <MatrialType />,
    },
    {
      path: 'colour',
      element: <ColourType />,
    },
    {
      path: 'specialization',
      element: <Specialization />,
    },
    {
      path: 'executor-type',
      element: <ExecutorType />,
    },
    {
      path: 'ventilation-size',
      element: <VentilationSize />,
    },
    {
      path: 'expense-type',
      element: <ExpenseType />,
    },
    {
      path: 'option',
      element: <Option />,
    },
    {
      path: 'type',
      element: <Type />,
    },
    {
      path: 'serial-type',
      element: <SerialType />,
    },
    {
      path: 'material/report/debit-order-transacts',
      element: <DebitOrderTransacts/>,
    },
    {
      path: 'material/report/debit-transacts',
      element: <DebitTransacts/>,
    },
    {
      path: 'material/report/debit-total-transacts',
      element: <DebitTotalTransact/>,
    },
    {
      path: 'material/report/debit-transact-summary',
      element: <DebitTransactSummary/>,
    },
    {
      path: 'material/report/full-order-list',
      element: <FullOrderList/>,
    },
    {
      path: 'material/report/total-transact-summary',
      element: <TotalTransactSummary/>,
    },
    {
      path: 'material/report/payments',
      element: <Payments/>,
    },
    {
      path: 'material/report/finance',
      element: <Finance/>,
    },
    {
      path: 'laboratory',
      element: <Laboratory/>,
    },
    {
      path: 'request',
      element: <Request/>,
    },
    {
      path: 'repair',
      element: <Repair/>,
    },
    {
      path: 'search-seria',
      element: <SearchSeria/>,
    },
    {
      path: 'home',
      element: <Home/>,
    },
    {
      path: 'qr',
      element: <QrScannerPage/>,
    },
  ],
};

export default AdminAppConfig;
